<template>
  <div class="accordion col-12 px-0 mx-0">
    <Colapsable
      tituloColapsable="Requisitos de ingreso"
      identificadorColapsable="accordion-requisitos"
      identificadorAcordion="detalles"
    >
      <RequisitosIngreso
        :requisitos="carrera.requisitosIngreso"
        :requisitoTexto="
          requisitoIngresoTexto(carrera.requisitosIngreso.textoRequisitoIngreso)
        "
      />
    </Colapsable>
    <Colapsable
      tituloColapsable="Información del programa"
      identificadorColapsable="accordion-egreso"
      identificadorAcordion="detalles"
    >
      <p
        style="text-align: justify"
        v-html="perfilEgresoTexto(carrera.perfilEgreso)"
      ></p>
    </Colapsable>
    <Colapsable
      tituloColapsable="Empleabilidad e ingresos"
      identificadorColapsable="accordion-empleo"
      identificadorAcordion="detalles"
    >
      <div class="input-lg row d-flex mx-auto">
        <p class="col-12 ml-0 pl-0 mr-auto">
          Dato de empleabilidad corresponde al porcentaje de titulados de las
          cohortes 2021, 2022 y 2023 de los cuales existe información sobre sus
          ingresos en los años 2022, 2023 y 2024, respectivamente.
          <br />Datos de ingresos promedios al 4 año considera cohortes de
          titulados 2018, 2019 y 2020 y los ingresos respectivos al cuarto año
          2022, 2023 y 2024.
        </p>
        <p class="col-12 ml-0 pl-0 mr-auto">
          Ambos datos han sido entregados por SIES en base a información del
          Servicio de Impuestos Internos.
        </p>
        <div class="col-11 mx-0 col-md-6 row kpi px-0 py-3 flex-nowrap">
          <img
            src="@/assets/img/img-empleabilidad.png"
            class="img-fluid"
            alt="Responsive image"
          />
          <div class="leyenda col-5 px-0 float-right">
            <p class="ml-n3">
              Empleabilidad
              <br />1 <span class="text-lowercase">er</span> año
              <br />
              <span class="text-azul font-weight-bold">{{
                empleabilidadText
              }}</span>
            </p>
          </div>
        </div>

        <div
          class="col-12 mx-0 col-md-6 row kpi px-0 py-3 float-right flex-nowrap"
        >
          <img
            src="@/assets/img/img-ingresos2.png"
            class="img-fluid"
            alt="Responsive image"
            style="max-height: 7.5rem"
          />
          <div class="leyenda col float-right pl-0 px-0 mx-n3">
            <p class>
              Ingreso promedio
              <br />4 <span class="text-lowercase">to</span> año
              <br />
              <span class="text-azul font-weight-bold">{{
                carrera.ingresoPromedioCuartoAnio
              }}</span>
            </p>
          </div>
        </div>
        <p
          class="mb-0"
          v-if="
            empleabilidadText === 'No Disponible' ||
              carrera.ingresoPromedioCuartoAnio === 'Sin Información Disponible'
          "
        >
          <small
            >* Carrera no cuenta con el número mínimo para ser considerado en la
            identificación de casos que realiza SII. Para más información
            <a :href="pdfEmpleabilidad" target="_blank">haz clic aquí</a
            >.</small
          >
        </p>
      </div>
    </Colapsable>
  </div>
</template>

<script>
import Ponderaciones from "@/components/fichaCarreraTP/Ponderaciones";
import Colapsable from "@/components/generales/paginas/Colapsable";
import RequisitosIngreso from "@/components/fichaCarreraTP/RequisitosIngreso";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ModalContacto } from "@/utils/BusesDeEventos.js";
import FormatoTextoMixins from "@/mixins/FormatearTextoURL.js";
library.add(faPlus, faMinus);
export default {
  name: "DetallesCarreraTP",
  props: {
    carrera: { type: Object }
  },
  mixins: [FormatoTextoMixins],
  components: {
    FontAwesomeIcon,
    Ponderaciones,
    Colapsable,
    RequisitosIngreso
  },
  data() {
    return {
      pdfEmpleabilidad: CDN.PDF_EMPLEABILIDAD_INGRESO
    };
  },
  computed: {
    empleabilidadText() {
      let valor = parseInt(this.carrera.porcentajeEmpleabilidad, 10);
      if (valor === 0) {
        return "No Disponible";
      } else {
        return `${this.carrera.porcentajeEmpleabilidad}%`;
      }
    }
  },
  methods: {
    requisitoIngresoTexto(text) {
      let texto = "";
      if (text) {
        texto = this.formatearTexto(text);
      }
      return texto;
    },
    perfilEgresoTexto(text) {
      let texto = "";
      if (text) {
        texto = this.formatearTexto(text);
      } else {
        texto = "Información No Disponible";
      }
      return texto;
    }
  }
};
</script>

<style>
.margen-inferior {
  margin-bottom: 1px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/fichaCarreraTP/DetallesCarreraTP.vue